import axios from 'lib/axios'
import { INineBoxAnalytics } from 'views/screens/Platform-administrator/Analytics/constants/types'

const getNineBoxAnalytics = async (body: INineBoxAnalytics) => {
  const nineBoxResults = await axios
    .post(`/nine-box/analytics`, body)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return { ok: false, message: error.message }
    })

  return nineBoxResults
}

export default getNineBoxAnalytics
